import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import useModalContext from './useModalContext';

/**
 * Header di una modale.
*/
const Header = ({ children }) => {
  const { dragging, onMouseDown } = useModalContext();
  return (
    <div
      className={cns(
        'v2-modal__header',
        'can-grab',
        {
          grabbing: dragging,
        },
      )}
      onMouseDown={onMouseDown}
      role="presentation"
    >
      {children}
    </div>
  );
};

Header.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Header.defaultProps = {
};

export default Header;
